import React, { useCallback, useEffect, useState } from "react";
//import SockJsClient from 'react-stomp';
import { StompSessionProvider, useSubscription } from "react-stomp-hooks";
import {
  CtmLiveOverViewType,
  useCtmLiveOverView,
} from "../ContextAPI/CtmLiveOverViewContext";
import {
  AssetOrLapsesChartData,
  RoutesSeverityChartData,
} from "../Models/Models";

const SOCKET_URL = "https://api.pixvisonz.com/v1/geo-websocket";

let token =
  "eyJraWQiOiI1Zk5ONXZncWFneXpZWXBHUHZjY2ZBMEw5all3U0FjU1BaM2JxVFUxQWVFPSIsImFsZyI6IlJTMjU2In0.eyJzdWIiOiI4Y2U3YzJmMi03OTg2LTQ4NTAtYTQ3Yi01YjJiMDc2YTM2YWIiLCJlbWFpbF92ZXJpZmllZCI6dHJ1ZSwiaXNzIjoiaHR0cHM6XC9cL2NvZ25pdG8taWRwLmFwLXNvdXRoZWFzdC0xLmFtYXpvbmF3cy5jb21cL2FwLXNvdXRoZWFzdC0xX0NvVGZ1VXFTUiIsImNvZ25pdG86dXNlcm5hbWUiOiI4Y2U3YzJmMi03OTg2LTQ4NTAtYTQ3Yi01YjJiMDc2YTM2YWIiLCJhdWQiOiI0MnVjM2ZnNnVtdGZqanJvN3BvdGkxazEzcSIsImV2ZW50X2lkIjoiZDU2OTlkOTAtN2IzZC00MTc4LTgzYjAtMjdlMTY1ZDU4ZDBhIiwidG9rZW5fdXNlIjoiaWQiLCJhdXRoX3RpbWUiOjE2Nzg3MDE4ODIsIm5hbWUiOiJBdXRvbWF0ZW5vdyIsImV4cCI6MTY3ODc4ODI4MiwiaWF0IjoxNjc4NzAxODgyLCJlbWFpbCI6ImF1dG9tYXRlbm93LmNvQGdtYWlsLmNvbSJ9.WUkxXOf5RwMFqCbkqArURkiv_QvzGizzmdUmehfrdHSe6Zh_yAEE9A-l8m6HInxQ9X8DfPf0cdWfYcOS_46hO6sM8hLTTmv0FRQ0lDqNinddWtzne6TK_T0VXwxXwDVvL4wUB04KbXOhrUEERF7w3wBifUoI30swLhl9q481J5yyyCf0zRIIfYdRsIcgRZOXwL7dCLtvsAWK2uAS9yicaI4NnxI-i4rHht_KfFe9-4wuGkTFZGmY4T23QzfWxJkswbWeMkaED5voZnmL-vY09OQtTUV3APTa-rHzRkosTix-0fKhZsnePZtouKqSLjnQwCK1z-r17NAKyXqXRE1XBA";

// //let authHeader = { Authorization: 'Bearer ' + token };

const ChartWebSocket = () => {
 
  const { ctmLiveOverViewState, dispatchCtmLiveOverView } =
    useCtmLiveOverView();

  const handleInputChange = useCallback(
    (
      field: keyof CtmLiveOverViewType,
      value:
        | string
        | boolean
        | number
        | null
        | AssetOrLapsesChartData[]
        | RoutesSeverityChartData[]
        | number[][]
        | mapboxgl.Map
    ) => {
      dispatchCtmLiveOverView({ type: "SET_FIELD", field, value });
    },
    [dispatchCtmLiveOverView]
  );

  const handleBulkChange = useCallback(
    (value: Partial<CtmLiveOverViewType>) => {
      dispatchCtmLiveOverView({ type: "BULK_UPDATE", value });
    },
    [dispatchCtmLiveOverView]
  );

  function authHeader(): string {
    return "Bearer " + token;
  }

  function SubscribingComponent() {
    useSubscription("/litter/chart/data", (message) => {
      onWsMessageReceived(message.body);
      //console.log("messagemessage", message.body);
    });
    return null;
  }

  const onWsMessageReceived = (message: any): void => {
    const msg = JSON.parse(message);
    var updateWebsocketData = {
      RoutesSeverityChartData: [...msg.routesSeverity],
      AssetCountChartData: [...msg.litterAssets],
      LapsesCountChartData: [...msg.litterLapses],
    };
    handleBulkChange(updateWebsocketData);
  };

  return (
    <StompSessionProvider
      url={SOCKET_URL}
      connectHeaders={{
        Authorization: authHeader(),
      }}
    >
      <SubscribingComponent />
    </StompSessionProvider>
  );
};
export default ChartWebSocket;
